import { createSelector } from '@ngrx/store';
import { VoucherBookingCountdown } from '@products/models/booking.model';
import { getProductBookingState } from '@store/products/product.selectors';

/**
 * Get product booking countdown
 * @description Gets countdown for product bookings
 * @returns Number which represents timestamp of when last product was booked
 */
export const getProductBookingCountdown = createSelector(
  getProductBookingState,
  (productBookingState): number => productBookingState.countdown.product
);

/**
 * Get vouchers booking countdown
 * @description Get countdowns for booked vouchers
 * @returns Array of booked vouchers which contains voucher code and timestamp
 */
export const getVoucherBookingCountdowns = createSelector(
  getProductBookingState,
  (productBookingState): VoucherBookingCountdown[] => productBookingState.countdown.voucher
);
